<template lang="html">
  <div :class="setClassBG()">
    <div v-if="isLoading" class="loadingLayout text-xs-center">
      <v-progress-circular :size="70" :width="5" indeterminate color="black"></v-progress-circular>
    </div>
    <v-container v-else>
      <section>
        <v-layout column align-center justify-center class="white--text border">
          <v-flex xs12 md12 class="hidden-sm-and-down">
            <h1 class="white--text mb-2 text-xs-center">วาระที่ {{agendaInfo.agenda}} {{agendaInfo.agenda_title}}</h1>
            <h2 class="white--text mb-2 text-xs-center">{{ memberInfo.firstname }} {{ memberInfo.lastname }}</h2>
            <h2 class="white--text mb-2 text-xs-center" v-if="memberInfo.proxyname !== null">ผู้มอบฉันทะ {{ memberInfo.proxyname }} {{ memberInfo.proxylastname }}</h2>
            <div class="subheading mb-3 text-xs-center">จำนวนหุ้น {{ setQShare(memberInfo.q_share) }} หุ้น</div>
          </v-flex>
          <v-flex xs12 md12 class="hidden-md-and-up">
            <h4 class="white--text mb-2 text-xs-center">วาระที่ {{agendaInfo.agenda}}</h4>
            <h5 class="white--text mb-2 text-xs-center">{{agendaInfo.agenda_title}}</h5>
            <h5 class="white--text mb-2 text-xs-center">{{ memberInfo.firstname }} {{ memberInfo.lastname }}</h5>
            <h5 class="white--text mb-2 text-xs-center" v-if="memberInfo.proxyname !== null">ผู้มอบฉันทะ {{ memberInfo.proxyname }} {{ memberInfo.proxylastname }}</h5>
            <h5 class="mb-3 text-xs-center">จำนวนหุ้น {{ setQShare(memberInfo.q_share) }} หุ้น</h5>
          </v-flex>
          <div v-if="submitVote" class="loadingLayout text-xs-center">
            <v-progress-circular :size="70" :width="5" indeterminate color="white"></v-progress-circular>
          </div>
          <v-flex v-if="!submitVote" xs12 sm6 class="py-2">
            <v-btn-toggle v-model="vote" style="background: transparent;">
              <v-btn round class="grey darken-2 mt-3 white--text" dark large value="เห็นด้วย">
                เห็นด้วย
              </v-btn>
              <v-btn round class="grey darken-2 mt-3 white--text" dark large value="ไม่เห็นด้วย">
                ไม่เห็นด้วย
              </v-btn>
              <v-btn round class="grey darken-2 mt-3 white--text" dark large value="งดออกเสียง">
                งดออกเสียง
              </v-btn>
              <v-btn round class="grey darken-2 mt-3 white--text" dark large value="บัตรเสีย">
                บัตรเสีย
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex v-if="!submitVote" xs6 md6>
            <v-btn class="red darken-4 mr-2 mt-4" dark @click.native="cancel">ยกเลิก</v-btn>
            <v-btn class="primary darken-4 mt-4" dark @click.native="saveData">บันทึก</v-btn>
          </v-flex>
        </v-layout>
      </section>
    </v-container>
  </div>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      isLoading: false,
      memberInfo: {
        firstname: '',
        lastname: '',
        q_share: ''
      },
      vote: undefined,
      agendaInfo: {
        agenda_id: '',
        agenda: '',
        agenda_title: '',
        calculatetype: ''
      },
      member_id: '',
      agenda_id: '',
      submitVote: false
    }
  },
  computed: {
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    },
    qrcodeId () {
      return this.$route.params.id.slice(1, this.$route.params.id.length)
    },
    scanType () {
      return this.$route.params.id.slice(0, 1)
    },
    userInfo () {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_information')))
      } else {
        return ''
      }
    }
  },
  created () {
    this.vote = undefined
  },
  methods: {
    setClassBG () {
      return [{'bg': !this.isLoading}]
    },
    checkVote () {
      if (this.qrcodeId) {
        var id = this.qrcodeId
        this.member_id = id.slice(0, id.length - 4)
        this.agenda_id = id.slice(-4)
      } else {
        if (this.scanType === 'w') {
          this.$router.push('/qrscanerweb')
        } else {
          this.$router.push('/qrscaner')
        }
        return
      }
      var source = { term: this.termYear.term, year: this.termYear.year, memberid: this.member_id, agenda_id: parseInt(this.agenda_id) }
      this.axios.post(process.env.API + '/checkVote', source).then((response) => {
        this.isLoading = false
        var result = response.data
        if (result.status === 'success') {
          this.vote = result.info.memberInfo.vote
          this.agendaInfo.agenda_title = result.info.agendaInfo.short_title
          this.agendaInfo.agenda_index = result.info.agendaInfo.agenda_index
          this.agendaInfo.agenda = result.info.agendaInfo.agenda
          this.agendaInfo.agenda_id = result.info.agendaInfo.agenda_id
          this.memberInfo.memberid = result.info.memberInfo.memberid
          this.memberInfo.firstname = result.info.memberInfo.firstname
          this.memberInfo.lastname = result.info.memberInfo.lastname
          this.memberInfo.proxyname = result.info.memberInfo.proxyname
          this.memberInfo.proxylastname = result.info.memberInfo.proxylastname
          this.memberInfo.q_share = result.info.memberInfo.q_share
        } else if (result.status === 'fail' && result.message === 'Not found memberid') {
          this.$swal('ไม่พบข้อมูลผู้ถือหุ้น', '', 'error')
          if (this.scanType === 'w') {
            this.$router.push('/qrscanerweb')
          } else {
            this.$router.push('/qrscaner')
          }
        } else if (result.status === 'fail' && result.message === 'Not found agenda_id') {
          this.$swal('ไม่พบข้อมูลวาระการประชุม', '', 'error')
          if (this.scanType === 'w') {
            this.$router.push('/qrscanerweb')
          } else {
            this.$router.push('/qrscaner')
          }
        } else {
          this.$swal('ไม่พบข้อมูล', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
          if (this.scanType === 'w') {
            this.$router.push('/qrscanerweb')
          } else {
            this.$router.push('/qrscaner')
          }
        }
      })
    },
    saveData () {
      if (!this.vote || this.submitVote) {
        return
      }
      this.submitVote = true
      var source = { term: this.termYear.term, year: this.termYear.year, memberid: this.member_id, agenda_id: parseInt(this.agenda_id), vote: this.vote, createby: this.userInfo.username }
      this.axios.post(process.env.API + '/vote', source).then((response) => {
        var me = this
        if (response.data.status === 'success') {
          this.submitVote = false
          this.$swal({
            title: 'บันทึกข้อมูลแล้ว',
            type: 'success'
          }).then(function () {
            me.$router.push('/vote/' + me.scanType + me.qrcodeId + '/submit')
            this.vote = undefined
          })
        } else {
          this.vote = undefined
          this.$swal('ไม่สามารถลงคะแนนไต้', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
          this.submitVote = false
        }
      })
    },
    cancel () {
      if (this.scanType === 'w') {
        this.$router.push('/qrscanerweb')
      } else {
        this.$router.push('/qrscaner')
      }
      localStorage.removeItem('content')
    },
    setQShare (number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 })
    }
  },
  mounted () {
    this.isLoading = true
    this.vote = undefined
    this.checkVote()
    window.addEventListener('keyup', event => {
      if (event.keyCode === 49) {
        this.vote = 'เห็นด้วย'
      } else if (event.keyCode === 50) {
        this.vote = 'ไม่เห็นด้วย'
      } else if (event.keyCode === 51) {
        this.vote = 'งดออกเสียง'
      } else if (event.keyCode === 52) {
        this.vote = 'บัตรเสีย'
      }
      // } else if (event.keyCode === 13) {
      //   // if (this.vote) {
      //   //   this.saveData()
      //   // }
      //   this.saveData()
      // }
    })
  }
}
</script>

<style lang="css" scoped>
.border{
  border-radius: 3em;
  border-spacing: 50px 70px;
  padding: 5em;
  opacity: 0.95;
  background: #000000;
}
.centerDiv{
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%)
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.btn-toggle{
  display: grid;
  background: transparent;
}
.btn-toggle .btn{
  opacity: 1 !important;
}
.btn--round, .btn--round:after {
  border-radius: 28px !important;
}
.btn-toggle .btn.btn--active{
  background-color: #002f03 !important;
  opacity: 1 !important;
}
.btn-toggle .btn:not(:last-child) {
    border-right: none !important;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.bg {
  background-image: url('/static/img/icons/104.jpg');
  height: 100%;
  /* height: -webkit-fill-available !important; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loadingLayout{
  width : 70%;
  height: 70%;
  margin: 10% auto;
}
@media only screen and (max-width: 600px) {
  .cg {
    height: auto !important;
  }
  .border{
    padding: 2em 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Scanqrcode.vue